export default __webpack_public_path__ + "static/media/background-music-key-visual.958b9374.svg";